import React from "react";
import Highcharts from "highcharts/highstock";
import BrandDark from 'highcharts/themes/brand-dark';
import HighchartsReact from "highcharts-react-official";

require("highcharts/indicators/indicators")(Highcharts);
require("highcharts/indicators/pivot-points")(Highcharts);
require("highcharts/indicators/macd")(Highcharts);
require("highcharts/modules/exporting")(Highcharts);
require("highcharts/modules/map")(Highcharts);
BrandDark(Highcharts);

function ThemedChartDark(props) {
    return <HighchartsReact {...props} ref={props.chartComponent} immutable={(props.mutable ? false : props.constructorType === 'stockChart')}  highcharts={Highcharts}/>
}

export default ThemedChartDark;